import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { KEYBOARD } from '../../utils/constants';

const Group = ({ className = '', id, style = {}, name, children }) => (
  <fieldset
    id={id}
    style={style}
    name={name}
    className={classNames('pf-radio-group', className)}
  >
    {children}
  </fieldset>
);

Group.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string,
  children: PropTypes.any,
};

const RadioButton = ({
  className = '',
  id,
  style,
  name,
  value,
  defaultChecked,
  checked,
  children,
  disabled = false,
  readOnly = false,
  onChange = () => null,
  tabIndex = 0,
}) => (
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
  <label
    className={classNames('pf-radio-btn', 'cursor-pointer', 'flex', className)}
    htmlFor={id}
    tabIndex={tabIndex}
    onKeyDown={(e) => {
      const keyPressed = e.key;
      if (keyPressed === KEYBOARD.ENTER) {
        try {
          e.target.value = value;
          onChange(e);
        } catch (ex) {
          console.error(ex);
        }
      }
    }}
  >
    <span
      className={classNames('pf-radio-btn-input-wrapper', {
        'pf-radio-btn-input-wrapper-checked': checked,
      })}
    >
      <input
        tabIndex={tabIndex}
        type="radio"
        className={classNames('pf-radio-btn-input')}
        id={id}
        style={style}
        name={name} // avoid using name for consistent checked value in UI
        value={value}
        defaultChecked={defaultChecked}
        checked={checked}
        disabled={disabled}
        readOnly={readOnly}
        onChange={onChange}
      />
    </span>
    <span className={classNames('margin-left-xxs')}>{children}</span>
  </label>
);

RadioButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  style: PropTypes.object,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  tabIndex: PropTypes.number,
};

export default { Group, Button: RadioButton };
